import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useEffect } from 'react';
import { ProductDetails } from '../../../integrations/relewise/types/mapped';
import { NEW_BUYBOX_MODULE_NAME } from '../cus-new-buybox.const';

export const useLogBuyboxMissingData = (productBuyboxData: ProductDetails | undefined, telemetry: ITelemetry) => {
    useEffect(() => {
        if (!productBuyboxData) {
            telemetry.error(`[${NEW_BUYBOX_MODULE_NAME}] Buybox data did not load, showing empty state.`);
        }
    }, [productBuyboxData, telemetry]);
};
